import {ProductList} from 'app/blocks/model/product-list.model';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IProductList} from 'app/blocks/model/product-list.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class ProductListService extends EntityCrudService<IProductList> {
    constructor(http: HttpClient) {
        // super(http, Resource.PRODUCT_LISTS, (obj?) => new ProductList(obj), true);
        super(http, Resource.PRODUCT_LISTS, (obj?) => new ProductList(obj));
    }

    applyProductListToCustomers = (id: any, customers: any, blackWhiteList: any): Promise<any> => {
        const params = new HttpParams().set('customers', customers).set('blackWhiteList', blackWhiteList);
        return this.http
            .post<any>(SERVER_API_URL + 'api/product-lists/apply/' + id, null, {
                observe: 'response',
                params: params
            })
            .toPromise();
    };

    applyProductListToDeliveryPoints = (id: any, deliveryPoints: any, blackWhiteList: any): Promise<any> => {
        const params = new HttpParams().set('deliveryPoints', deliveryPoints).set('blackWhiteList', blackWhiteList);
        return this.http
            .post<any>(SERVER_API_URL + 'api/product-lists/apply/' + id, null, {
                observe: 'response',
                params: params
            })
            .toPromise();
    };

    bulkAddProductsToProductLists = (productIds: number[], productListIds: number[]): Promise<any> => {
        const requestBody = {
            productIds: productIds,
            productListIds: productListIds
        };
        return this.http
            .post<any>(SERVER_API_URL + 'api/product-lists/bulk-add-products', requestBody, {
                observe: 'response'
            })
            .toPromise();
    };

    bulkRemoveProductsFromProductLists = (productIds: number[], productListIds: number[]): Promise<any> => {
        const requestBody = {
            productIds: productIds,
            productListIds: productListIds
        };
        return this.http
            .post<any>(SERVER_API_URL + 'api/product-lists/bulk-remove-products', requestBody, {
                observe: 'response'
            })
            .toPromise();
    };

    getProductListsContainingProducts = (productIds: number[], page: number, size: number, searchQuery?: string, sort?: string): Promise<any> => {
        let params = new HttpParams().set('productIds', productIds.join(',')).set('page', page.toString()).set('size', size.toString());

        if (searchQuery) {
            params = params.set('query', searchQuery);
        }

        if (sort) {
            params = params.set('sort', sort);
        }

        return this.http
            .get<any>(SERVER_API_URL + 'api/product-lists/containing-products', {
                observe: 'response',
                params: params
            })
            .toPromise();
    };

    getProductListsContainingProductCodes = (
        productCodes: string[],
        page: number,
        size: number,
        searchQuery?: string,
        sort?: string
    ): Promise<any> => {
        let params = new HttpParams().set('productCodes', productCodes.join(',')).set('page', page.toString()).set('size', size.toString());

        if (searchQuery) {
            params = params.set('query', searchQuery);
        } else {
            params = params.set('query', ''); // Empty query for search endpoint
        }

        if (sort) {
            params = params.set('sort', sort);
        }

        return this.http
            .get<any>(SERVER_API_URL + 'api/_search/product-lists', {
                observe: 'response',
                params: params
            })
            .toPromise();
    };
}
